import React, { useState } from 'react';
import { Mail, MessageSquare, MapPin, Send, Instagram, Facebook } from 'lucide-react';
import PageHeader from '../components/PageHeader';
import SEO from '../components/SEO';

const Contact = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });

  const handleSubmit = (e) => {
    e.preventDefault();
    // Qui potresti collegarlo a Supabase o EmailJS, per ora apre il client di posta
    window.location.href = `mailto:info@tusciahub.it?subject=Messaggio da ${formData.name}&body=${formData.message}`;
  };

  return (
    <div className="relative min-h-screen bg-slate-50 pt-24 pb-20 px-6 font-sans text-slate-800">
      <SEO title="Contattaci" description="Hai domande o suggerimenti? Scrivici." url="/contact" />
      
      <div className="absolute top-0 right-[-10%] w-[500px] h-[500px] bg-indigo-100/60 rounded-full blur-[100px] mix-blend-multiply pointer-events-none"></div>

      <div className="relative z-10 max-w-5xl mx-auto">
        <PageHeader title="Contattaci" subtitle="Siamo qui per aiutarti." breadcrumbs={[{label: 'Contatti'}]} />

        <div className="grid md:grid-cols-2 gap-12 items-start">
            
            {/* Info Box */}
            <div className="space-y-8">
                <div className="bg-white p-8 rounded-[2.5rem] shadow-sm border border-slate-100 space-y-6">
                    <h3 className="text-2xl font-black text-slate-900">I nostri canali</h3>
                    
                    <div className="flex items-center gap-4">
                        <div className="bg-indigo-50 p-3 rounded-2xl text-indigo-600"><Mail size={24}/></div>
                        <div>
                            <p className="text-xs font-bold text-slate-400 uppercase tracking-widest">Email</p>
                            <a href="mailto:info@tusciahub.it" className="font-bold text-lg hover:text-indigo-600 transition">info@tusciahub.it</a>
                        </div>
                    </div>

                    <div className="flex items-center gap-4">
                        <div className="bg-pink-50 p-3 rounded-2xl text-pink-600"><Instagram size={24}/></div>
                        <div>
                            <p className="text-xs font-bold text-slate-400 uppercase tracking-widest">Instagram</p>
                            <a href="https://instagram.com/tusciahub" target="_blank" rel="noreferrer" className="font-bold text-lg hover:text-pink-600 transition">@tusciahub</a>
                        </div>
                    </div>

                    <div className="flex items-center gap-4">
                        <div className="bg-blue-50 p-3 rounded-2xl text-blue-600"><Facebook size={24}/></div>
                        <div>
                            <p className="text-xs font-bold text-slate-400 uppercase tracking-widest">Facebook</p>
                            <a href="#" className="font-bold text-lg hover:text-blue-600 transition">TusciaHub Community</a>
                        </div>
                    </div>
                </div>

                <div className="bg-slate-900 text-white p-8 rounded-[2.5rem] relative overflow-hidden">
                    <div className="relative z-10">
                        <h3 className="text-xl font-bold mb-2">Sei uno sviluppatore?</h3>
                        <p className="text-slate-400 text-sm mb-4">Il progetto è open source e gestito dagli studenti. Se vuoi contribuire al codice, scrivici!</p>
                        <button className="bg-white text-slate-900 px-4 py-2 rounded-xl font-bold text-sm hover:bg-indigo-50 transition">Unisciti al Team</button>
                    </div>
                    <div className="absolute top-0 right-0 w-32 h-32 bg-indigo-500 rounded-full blur-3xl -mr-10 -mt-10 opacity-20"></div>
                </div>
            </div>

            {/* Form */}
            <div className="bg-white p-8 rounded-[2.5rem] shadow-lg border border-slate-100">
                <h3 className="text-2xl font-black text-slate-900 mb-6 flex items-center gap-2">
                    <MessageSquare className="text-indigo-600"/> Inviaci un messaggio
                </h3>
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-1">Nome</label>
                        <input type="text" required className="w-full bg-slate-50 border border-slate-200 rounded-xl p-4 font-bold text-slate-800 focus:ring-2 focus:ring-indigo-500 outline-none" placeholder="Il tuo nome" value={formData.name} onChange={e => setFormData({...formData, name: e.target.value})}/>
                    </div>
                    <div>
                        <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-1">Email</label>
                        <input type="email" required className="w-full bg-slate-50 border border-slate-200 rounded-xl p-4 font-bold text-slate-800 focus:ring-2 focus:ring-indigo-500 outline-none" placeholder="tua@studenti.unitus.it" value={formData.email} onChange={e => setFormData({...formData, email: e.target.value})}/>
                    </div>
                    <div>
                        <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-1">Messaggio</label>
                        <textarea required className="w-full bg-slate-50 border border-slate-200 rounded-xl p-4 font-medium text-slate-800 h-32 resize-none focus:ring-2 focus:ring-indigo-500 outline-none" placeholder="Come possiamo aiutarti?" value={formData.message} onChange={e => setFormData({...formData, message: e.target.value})}></textarea>
                    </div>
                    <button type="submit" className="w-full bg-indigo-600 text-white py-4 rounded-xl font-bold hover:bg-indigo-700 transition shadow-lg shadow-indigo-200 flex items-center justify-center gap-2">
                        <Send size={18}/> Invia Messaggio
                    </button>
                </form>
            </div>

        </div>
      </div>
    </div>
  );
};

export default Contact;